import { formatNumberMix } from '@/utils'
export default {
    data() { },
    methods: {
        setCountList(data) {
            let list = new Array(4).fill(null)
            list[0] = {
                title: this.$t('performance-analysis::cost_title'),
                count: data && this.$dataCheck(formatNumberMix(data.totalCostRate, 2, ',')),
                lastCount: data && this.$dataCheck(formatNumberMix(data.lastTotalCostRate, 2, ',')),
                down: data && data.totalCostRateRatio ? data.totalCostRateRatio < 0 : false,
                rate: data && this.$dataCheck(formatNumberMix(data.totalCostRateRatio, 2)),
                statisticsDays: data && this.$dataCheck(data.statisticsDays),
                prefix: data && data.currency,
                tooltip: this.$t('performance-analysis::cost_tooltip')
                // disable: true
            }
            list[1] = {
                title: this.$t('performance-analysis::internet_title'),
                count: data && this.$dataCheck(formatNumberMix(data.internetRate, 2, ',')),
                lastCount: data && this.$dataCheck(formatNumberMix(data.lastInternetRate, 2, ',')),
                down: data && data.internetRateRatio ? data.internetRateRatio < 0 : false,
                statisticsDays: data && this.$dataCheck(data.statisticsDays),
                rate: data && this.$dataCheck(formatNumberMix(data.internetRateRatio, 2)),
                suffix: '%',
                tooltip: this.$t('performance-analysis::internet_tooltip')
            }
            list[2] = {
                title: this.$t('performance-analysis::fiveSend_title'),
                count: data && this.$dataCheck(formatNumberMix(data.day5ShippingRate, 2, ',')),
                lastCount: data && this.$dataCheck(formatNumberMix(data.lastDay5ShippingRate, 2, ',', '%')),
                statisticsDays: data && this.$dataCheck(data.statisticsDays),
                down: data && data.day5ShippingRateRatio ? data.day5ShippingRateRatio < 0 : false,
                rate: data && this.$dataCheck(formatNumberMix(data.day5ShippingRateRatio, 2)),
                suffix: '%',
                tooltip: this.$t('performance-analysis::fiveSend_tooltip')
            }
            list[3] = {
                title: this.$t('performance-analysis::thirtyReceive_title'),
                count: data && this.$dataCheck(formatNumberMix(data.day30ReceivedOkRate, 2, ',')),
                lastCount: data && this.$dataCheck(formatNumberMix(data.lastDay30ReceivedOkRate, 2, ',')),
                statisticsDays: data && this.$dataCheck(data.statisticsDays),
                down: data && data.day30ReceivedOkRateRatio ? data.day30ReceivedOkRateRatio < 0 : false,
                rate: data && this.$dataCheck(formatNumberMix(data.day30ReceivedOkRateRatio, 2)),
                suffix: '%',
                tooltip: this.$t('performance-analysis::thirtyReceive_tooltip')
            }
            return list
        },
        setDelieveredLineChartsConfig(data = []) {
            return {
                title: this.$t('performance-analysis::barCharts_title'),
                type: 'bar',
                ref: 'barChart',
                height: '325px',
                chart: {
                    legend: {
                        data: [this.$t('performance-analysis::barCharts_sendRate'), this.$t('performance-analysis::barCharts_receiveRate')]
                    },
                    tooltip: {
                        formatter: (params, ticket, callback) => {
                            let str = ''
                            params.forEach(item => {
                                str += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span>`
                                str += `<span>${item.seriesName} </span><span style="font-weight:900;">${item.value}%</span> <br/> `
                            })
                            return str
                        }
                    },
                    xAxis: {
                        data: data.map(item => item.date)
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            lineStyle: {
                                color: '#999999',
                                type: 'dashed'
                            }
                        },
                        min: 0,
                        axisLabel: {
                            margin: 16,
                            color: '#999999',
                            formatter: '{value} %'
                        }
                    },
                    series: [
                        {
                            name: this.$t('performance-analysis::barCharts_sendRate'),
                            type: 'bar',
                            data: data.map(item => Number(item.shippingRate))
                        },
                        {
                            name: this.$t('performance-analysis::barCharts_receiveRate'),
                            type: 'bar',
                            data: data.map(item => Number(item.receivedOkRate))
                        }
                    ]
                }
            }
        },
        setShippingTableConfig(data = []) {
            return {
                title: this.$t('performance-analysis::send::table_title'),
                ref: 'shippingTable',
                height: '325px',
                cancelShadow: true,
                tableData: data
            }
        },
        setDelieveredTableConfig(data = []) {
            return {
                title: this.$t('performance-analysis::receive::table_title'),
                ref: 'delieveredTable',
                height: '325px',
                cancelShadow: true,
                tableData: data
            }
        }
    }
}
